import { AnuncioStatusEnum } from 'core/features/anuncio/typings';

export function getTagVariantForStatus(status: AnuncioStatusEnum) {
    if (status === AnuncioStatusEnum.Rejeitado) {
        return "solid";
    }
    return "outline";
}

export function getTagColorSchemeForStatus(status: AnuncioStatusEnum) {

    switch (status) {
        case AnuncioStatusEnum.Aprovado:
            return "green";
        case AnuncioStatusEnum.Pendente:
        case AnuncioStatusEnum.Rejeitado:
            return "red";
        case AnuncioStatusEnum.EmAnalise:
           return "orange";
        default:
            return "gray";
    }

}